import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountComponent } from './account/account.component';
import { AccountsettingsComponent } from './accountsettings/accountsettings.component';
import { AccountchangepasswoerdComponent } from './accountchangepasswoerd/accountchangepasswoerd.component';
import { InviteandearnComponent } from './inviteandearn/inviteandearn.component';
import { VouchersComponent } from './vouchers/vouchers.component';
import { DocumentsComponent } from './documents/documents.component';
import { SupportComponent } from './support/support.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import {AppCommonModule} from "../common/common.module";



@NgModule({
  declarations: [
    AccountComponent,
    AccountsettingsComponent,
    AccountchangepasswoerdComponent,
    InviteandearnComponent,
    VouchersComponent,
    DocumentsComponent,
    SupportComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    NgbPopoverModule,
    AppCommonModule
  ]
})
export class AccountModule { }
